import { render } from "./humKxjMode.vue?vue&type=template&id=24f7d8e8&scoped=true"
import script from "./humKxjMode.vue?vue&type=script&lang=js"
export * from "./humKxjMode.vue?vue&type=script&lang=js"

import "./humKxjMode.vue?vue&type=style&index=0&id=24f7d8e8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f7d8e8"]])

export default __exports__